"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _initializerDefineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerDefineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));

var _initializerWarningHelper2 = _interopRequireDefault(require("@babel/runtime/helpers/initializerWarningHelper"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _mobx = require("mobx");

var _lodash = _interopRequireDefault(require("lodash"));

var _styling = require("../../../toolkit/styling");

var _providers = require("../../../toolkit/providers");

var _DayPickerInput = _interopRequireDefault(require("./DayPickerInput"));

var _dimen = require("../../../toolkit/dimen");

var _class, _class2, _descriptor, _descriptor2, _descriptor3, _descriptor4, _class3, _temp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

var DayRangePickerInput = (0, _mobxReact.observer)(_class = (_class2 = (_temp = _class3 = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(DayRangePickerInput, _Component);

  var _super = _createSuper(DayRangePickerInput);

  function DayRangePickerInput() {
    var _this;

    (0, _classCallCheck2["default"])(this, DayRangePickerInput);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.context = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "from", _descriptor, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "to", _descriptor2, (0, _assertThisInitialized2["default"])(_this));
    _this.toInputRef = void 0;
    (0, _initializerDefineProperty2["default"])(_this, "handleFromChange", _descriptor3, (0, _assertThisInitialized2["default"])(_this));
    (0, _initializerDefineProperty2["default"])(_this, "handleToChange", _descriptor4, (0, _assertThisInitialized2["default"])(_this));

    _this.focusToInput = function () {
      if (_this.toInputRef) {
        var textInputForDayPicker = _this.toInputRef.getInput();

        if (textInputForDayPicker) {
          textInputForDayPicker.focus();
        }
      }
    };

    return _this;
  }

  (0, _createClass2["default"])(DayRangePickerInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          fromDate = _this$props.fromDate,
          toDate = _this$props.toDate;
      this.from = fromDate;
      this.to = toDate;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(provProps) {
      var _this$props2 = this.props,
          fromDate = _this$props2.fromDate,
          toDate = _this$props2.toDate,
          preventEmptyDate = _this$props2.preventEmptyDate;

      if (fromDate !== provProps.fromDate || this.from == null && preventEmptyDate) {
        // parent passes in the "fromDate"
        this.from = fromDate;
      }

      if (toDate !== provProps.toDate || this.to == null && preventEmptyDate) {
        // parent passes in the "toDate"
        this.to = toDate;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props3 = this.props,
          style = _this$props3.style,
          className = _this$props3.className,
          dayPickerProps = _this$props3.dayPickerProps,
          fromDate = _this$props3.fromDate,
          toDate = _this$props3.toDate,
          onDayRangeChange = _this$props3.onDayRangeChange,
          disableBeforeStartDays = _this$props3.disableBeforeStartDays,
          value = _this$props3.value,
          onDayChange = _this$props3.onDayChange,
          props = (0, _objectWithoutProperties2["default"])(_this$props3, ["style", "className", "dayPickerProps", "fromDate", "toDate", "onDayRangeChange", "disableBeforeStartDays", "value", "onDayChange"]);
      var corePrimaryLightest = this.context.theming.theme.corePrimaryLightest;
      var mergeDayPickerProps = dayPickerProps || {};

      if (!mergeDayPickerProps.hasOwnProperty("showOutsideDays")) {
        mergeDayPickerProps.showOutsideDays = true;
      }

      var modifiers = {
        start: this.from,
        end: this.to,
        range: {}
      };

      if (this.from && this.to && this.from < this.to) {
        modifiers.range = {
          before: this.to,
          after: this.from
        };
      }

      var fromTime = this.from ? this.from.getTime() : 0;
      var toTime = this.to ? this.to.getTime() : 1;
      var isSameDay = toTime == fromTime;
      var modifiersStyles = {
        start: {
          borderRadius: isSameDay ? "50%" : "50% 0 0 50%",
          backgroundColor: corePrimaryLightest
        },
        end: {
          borderRadius: isSameDay ? "50%" : "0 50% 50% 0",
          backgroundColor: corePrimaryLightest
        },
        range: {
          borderRadius: 0,
          backgroundColor: corePrimaryLightest
        }
      };
      mergeDayPickerProps.modifiers = modifiers;
      mergeDayPickerProps.modifiersStyles = modifiersStyles;

      var mergeDayPickerPropsFrom = _objectSpread({
        onDayClick: function onDayClick() {
          _this2.focusToInput();
        }
      }, mergeDayPickerProps);

      var rootCSS = (0, _styling.css)(this.styles.root, style, className);

      var mergeDayPickerPropsTo = _objectSpread({
        disabledDays: function disabledDays(d) {
          return false;
        }
      }, mergeDayPickerProps);

      if (disableBeforeStartDays) {
        var isBeforeStart = function isBeforeStart(date) {
          if (_this2.from) {
            return date < _this2.from;
          }
        };

        if (!mergeDayPickerPropsTo.hasOwnProperty("disabledDays")) {
          mergeDayPickerPropsTo.disabledDays = isBeforeStart;
        } else {
          var currentDisabledDays = mergeDayPickerPropsTo.disabledDays;

          mergeDayPickerPropsTo.disabledDays = function (date) {
            return isBeforeStart(date) || currentDisabledDays(date);
          };
        }
      }

      return /*#__PURE__*/_react["default"].createElement("div", {
        className: rootCSS
      }, /*#__PURE__*/_react["default"].createElement(_DayPickerInput["default"], (0, _extends2["default"])({
        className: (0, _styling.css)(this.styles.input) // if this.from is null, the prev display value won't be cleared.
        // have to set to empty string
        ,
        value: this.from ? this.from : "",
        onDayChange: this.handleFromChange,
        dayPickerProps: mergeDayPickerPropsFrom
      }, props)), /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _styling.css)(this.styles.hyphen)
      }, "to"), /*#__PURE__*/_react["default"].createElement(_DayPickerInput["default"], (0, _extends2["default"])({
        ref: function ref(input) {
          return _this2.toInputRef = input;
        },
        className: (0, _styling.css)(this.styles.input) // if this.to is null, the prev display value won't be cleared.
        // have to set to empty string
        ,
        value: this.to ? this.to : "",
        alignRight: true,
        onDayChange: this.handleToChange,
        dayPickerProps: mergeDayPickerPropsTo
      }, props)));
    }
  }, {
    key: "styles",
    get: function get() {
      var dimenStore = _dimen.DimenStore.instance();

      return _aphrodite.StyleSheet.create({
        root: {
          display: "flex",
          flexDirection: !dimenStore.isSmallScreen ? "row" : "column",
          flexWrap: "wrap"
        },
        input: {
          flex: 1
        },
        hyphen: {
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
          margin: "0 8px"
        }
      });
    }
  }]);
  return DayRangePickerInput;
}(_react.Component), _class3.contextType = _providers.LegoContext, _class3.propDoc = _objectSpread(_objectSpread({}, _lodash["default"].omit(_DayPickerInput["default"].propDoc, ["onDayChange"])), {}, {
  fromDate: {
    required: false,
    defaultValue: "null",
    type: "Date",
    description: "The initial starting date of the range"
  },
  toDate: {
    required: false,
    defaultValue: "null",
    type: "Date",
    description: "The initial end date of the range"
  },
  onDayRangeChange: {
    required: false,
    defaultValue: "null",
    type: "(from: Date, to: Date) => mixed",
    description: "The event callback when day range changes"
  }
}), _class3.demoProps = {
  noEdit: true,
  onDayRangeChange: function onDayRangeChange(from, to) {}
}, _class3.discussion = "\n  It accepts almost any props that are valid to DayPickerInput\n  except `onDayChange`\n  ", _temp), (_descriptor = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "from", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "to", [_mobx.observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "componentDidMount", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "componentDidMount"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "componentDidUpdate", [_mobx.action], Object.getOwnPropertyDescriptor(_class2.prototype, "componentDidUpdate"), _class2.prototype), (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "styles", [_mobx.computed], Object.getOwnPropertyDescriptor(_class2.prototype, "styles"), _class2.prototype), _descriptor3 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "handleFromChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (date) {
      _this3.from = date;

      if (_this3.from && _this3.to && _this3.from > _this3.to) {
        _this3.to = null;
      }

      if (_this3.props.onDayRangeChange) {
        _this3.props.onDayRangeChange(_this3.from, _this3.to);
      }
    };
  }
}), _descriptor4 = (0, _applyDecoratedDescriptor2["default"])(_class2.prototype, "handleToChange", [_mobx.action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (date) {
      _this4.to = date;

      if (_this4.from && _this4.to && _this4.from > _this4.to) {
        _this4.from = null;
      }

      if (_this4.props.onDayRangeChange) {
        _this4.props.onDayRangeChange(_this4.from, _this4.to);
      }
    };
  }
})), _class2)) || _class;

var _default = DayRangePickerInput;
exports["default"] = _default;